import 'core-js';
import 'regenerator-runtime/runtime';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Bootstrap 및 BootstrapVue CSS 파일 가져오기(순서 중요) 
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import vueMoment from 'vue-moment'
import { Doughnut } from "vue-chartjs";
import  'bootstrap/dist/css/bootstrap.css' 
import  'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue2-timepicker/dist/VueTimepicker.css';
import 'vue2-datepicker/index.css';
import './assets/scss/_index.scss'
import 'swiper/css/swiper.min.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { Swiper,SwiperSlide } from 'vue-awesome-swiper'
import VueTimepicker from 'vue2-timepicker'
import VueDatePicker from 'vue2-datepicker';
import VueMobileDatePicker from 'vuejs-mobile-datepicker';


Vue.config.productionTip = false

// 프로젝트 전체에서 BootstrapVue를 사용할 수 있도록 합니다.
Vue.use(BootstrapVue)
// 선택적으로 BootstrapVue 아이콘 구성 요소 플러그인을 설치합니다. 
Vue.use(IconsPlugin)

Vue.use(VueTimepicker)
Vue.use(vueMoment)
Vue.use(Doughnut)
Vue.use(VueAwesomeSwiper);
Vue.use(VueTimepicker);
Vue.use(VueDatePicker);
Vue.use(VueMobileDatePicker);

Vue.config.productionTip = false

Vue.config.warnHandler = (msg, vm, trace) => {
  if (msg.includes('prescrbeCategoryList')) {
    console.log('⚠️ warn msg:', msg);
    console.log('⚠️ component:', vm && vm.$options && vm.$options.name);
    console.log('⚠️ trace:', trace);
    console.log('⚠️ data keys:', vm ? Object.keys(vm.$data || {}) : null);
  }
}

new Vue({
  router,
  store,
  render: h => h(App, Swiper, SwiperSlide, VueTimepicker)
}).$mount('#app')

